import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/grupopessoa?${serialize(filtros)}`, { tela: 'grupo_pessoa' })
}

export async function get (id) {
  return httpAuth.get(`/grupopessoa/${id}`, { tela: 'grupo_pessoa' })
}

export async function add (dados) {
  return httpAuth.post(`/grupopessoa`, dados, { funcionalidade: 'grupo_pessoa_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/grupopessoa/${id}`, dados, { funcionalidade: 'grupo_pessoa_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/grupopessoa/${id}`, { funcionalidade: 'grupo_pessoa_excluir' })
}
